// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1HFXi","box":"WorkspacesBox_box__-WdPY","node":"WorkspacesBox_node__YCg3q"};